import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { api } from '../lib/api'
import { useAuth } from '../lib/auth'

export function GamePage() {
  const { id } = useParams()
  const { token } = useAuth()
  const [game, setGame] = useState<any>(null)
  const [result, setResult] = useState<any>(null)
  const [msg, setMsg] = useState<string | null>(null)

  async function load() {
    const res = await api<{ game: any; result: any }>(`/api/games/${id}`, { token })
    setGame(res.game)
    setResult(res.result)
  }

  useEffect(() => {
    load().catch(console.error)
  }, [id, token])

  async function submitTrivia() {
    await api(`/api/games/${id}/input`, {
      method: 'POST',
      token,
      body: {
        payload: {
          answers: {
            q1: { answer: 'Brazil', responseMs: 300 },
            q2: { answer: '1994', responseMs: 400 },
          },
        },
      },
    })
    setMsg('Input accepted')
    await load()
  }

  async function submitReaction() {
    await api(`/api/games/${id}/input`, {
      method: 'POST',
      token,
      body: { payload: { taps: { m1: { reactionMs: 150 }, m2: { reactionMs: 220 } } } },
    })
    setMsg('Reaction taps sent')
    await load()
  }

  async function submitPrediction() {
    await api(`/api/games/${id}/input`, {
      method: 'POST',
      token,
      body: { payload: { prediction: 'KO', confidence: 3 } },
    })
    setMsg('Prediction locked')
    await load()
  }

  async function resolve() {
    const res = await api<{ result: any }>(`/api/games/${id}/resolve`, { method: 'POST', token })
    setResult(res.result)
    setMsg('Resolved — seed revealed')
    await load()
  }

  if (!game) return <div className="panel">Loading game…</div>

  return (
    <div className="stack">
      <section className="hero-fight" style={{ minHeight: 160 }}>
        <div
          className="bg"
          style={{ backgroundImage: 'url(/assets/mma/mini-game-icon-set/trivia.png)', backgroundSize: '180px', backgroundRepeat: 'no-repeat', backgroundPosition: '90% center' }}
        />
        <div className="veil" />
        <div className="content">
          <div className="eyebrow">Mini-game</div>
          <h1>{game.gameType}</h1>
          <div className="meta">
            <span>{game.status}</span>
            <span>seed {game.seedCommit?.slice(0, 8)}…</span>
            {game.seedReveal && <span>reveal ok</span>}
          </div>
        </div>
      </section>
      <div className="panel">
        {msg && <div className="success">{msg}</div>}
        <div className="row">
          {game.gameType === 'trivia-duel' && (
            <button className="btn" onClick={submitTrivia}>
              Submit trivia answers
            </button>
          )}
          {game.gameType === 'reaction-challenge' && (
            <button className="btn" onClick={submitReaction}>
              Submit reactions
            </button>
          )}
          {game.gameType === 'prediction-duel' && (
            <button className="btn" onClick={submitPrediction}>
              Submit prediction
            </button>
          )}
          <button className="btn secondary" onClick={resolve}>
            Host resolve
          </button>
        </div>
        {result && (
          <pre style={{ overflow: 'auto', fontSize: 11, marginTop: 12, background: '#0b1220', color: '#e2e8f0', padding: 10, borderRadius: 4 }}>
            {JSON.stringify(result, null, 2)}
          </pre>
        )}
      </div>
    </div>
  )
}
